import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

import { ConfirmationModalComponent } from './confirmation-modal.component';
import { ModalModule } from '../modal/modal.module';

@NgModule({
    imports: [
        CommonModule,
        ModalModule,
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: PublicHttpLoaderFactory,
                deps: [HttpClient],
            },
        }),
        // SimpleModalModule.forRoot({container: 'modal-container'})
    ],
    declarations: [ConfirmationModalComponent],
    exports: [ConfirmationModalComponent],
})
export class ConfirmationModalModule {}

export function PublicHttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/public/', '.json');
}
